import { connect } from 'react-redux';
import { change } from 'redux-form';
import ResidentialAddressForm from './component';

const mapDispatchToProps = {
  change,
};

export default connect(null, mapDispatchToProps)(ResidentialAddressForm);
